import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {setAuthTokenAction} from '../../actions/auth';
import exchangeToken from '../../endpoints/exchangeToken';
import strings from '../../strings';
import Login from '../../components/Login';
import literateLogo from '../../assets/images/logo-white-2.png';
import {SOCKET_ENDPOINT, CHILD_TEST_URL} from '../../constants';
import AudioPlayer from '../../components/AudioPlayer';
import welComeAudio from '../../assets/sounds/se/intros/Test-start.mp3';

import queryString from 'query-string';
import {Howl,Howler} from 'howler';
import nosound from '../../assets/nosound.mp3';
import './styles.scss';

const parsedSearch = queryString.parse(window.location.search);
const verifyAuth = async (key, token) => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('Authorization', 'Bearer ' + token);

	const response = await fetch(SOCKET_ENDPOINT + '/token/verify?key=' + key, {
		method: 'get',
		headers,
	});

	if (response.ok) {
		return response.json();
	}
	return await Promise.reject(response);
};
const excludeForLang = ['de', 'se'];
class SelectRole extends Component {
	constructor(props) {
		super(props);

		this.welcome_audio = welComeAudio;

		this.state = {
			currentView: excludeForLang.includes(strings.getLanguage())
				? 'initial'
				: 'candidate',
			testKey: '',
			roomKey: '',
			adminEmail: '',
			testKeyType: '',
			hasEnteredCode: false,
			ageGroup: null,
			askForPincode: false,
			failStartInstruction: this.props.failStart,
			altError: null,
		};
	}

	componentWillMount = () => {
		let search = parsedSearch;
		let params = new URLSearchParams(search);
		let key = params.get('key');
		let role = params.get('role');
		let testKeyType = params.get('type');
		let token = params.get('token');
		let ageGroup = params.get('group');

		let authToken = localStorage.getItem('authtoken-child');
		if (authToken) window.localStorage.removeItem('authtoken-child');
		if (role === 'admin') {
			this.setState({
				currentView: 'testadmin',
				testKey: key,
				testKeyType: testKeyType,
				ageGroup: ageGroup,
				token: token,
				hasEnteredCode: false,
			});
			if (key && token) {
				verifyAuth(key, token).then((res) => {
					console.log('authorized');
					this.props.setAuthToken(token);
					this.onAdminSubmit();
				});
			}
		} else if (role === 'candidate') {
			this.setState({
				currentView: 'candidate',
				roomKey: key,
				testKeyType: testKeyType,
				ageGroup: ageGroup
			});
		}
	};

	stopAllAudio = () => {
  // Newer Howler (>=2.2.0)
  if (Howler && typeof Howler.stop === 'function') {
    Howler.stop();
    return;
  }

  // Older Howler: unload exists and also stops all sounds
  if (Howler && typeof Howler.unload === 'function') {
    Howler.unload();
    return;
  }

  // Last-resort: internal list of Howl instances
  if (Howler && Array.isArray(Howler._howls)) {
    Howler._howls.forEach(h => {
      try { h.stop && h.stop(); h.unload && h.unload(); } catch (e) {}
    });
  }
};


	onAdminSubmit = (e) => {
		if (e && e.preventDefault) e.preventDefault();

		const {onSelectRole} = this.props;
		const {testKey, adminEmail, testKeyType, ageGroup} = this.state;

		onSelectRole('testadmin', testKey, testKeyType, adminEmail, ageGroup);

		return false;
	};



	onCandidateSubmit = (e) => {
  e.preventDefault();

  // ✅ hard stop anything currently playing (including welcomeAudio)
 this.stopAllAudio();
  // optional but strong: frees audio buffers too
  // Howler.unload();

  // Fix your silent loop too (you currently assign the soundId to global.myAudio)
  try {
    if (global.myAudio && typeof global.myAudio.stop === 'function') {
      global.myAudio.stop();
      global.myAudio.unload?.();
    }
  } catch (_) {}

  global.myAudio = new Howl({
    src: [nosound],
    html5: true,
    loop: true,
    volume: 0,
  });
  global.myAudio.play();

  const {onSelectRole} = this.props;
  const {roomKey, testKeyType, ageGroup, adminEmail} = this.state;
  onSelectRole('testuser', roomKey, testKeyType, adminEmail,  ageGroup);

  return false;
};

	render() {
		const {currentView, hasEnteredCode, testKey, testKeyType} = this.state;

		return (
			<div className="SelectRole">
				<div className="lit-logo-wrapper" style={{marginTop: '15px'}}>
					<img
						src={literateLogo}
						alt="Literate"
						className="title__logo"
					/>
				</div>
				<div className="SelectRoleContainer">
					{currentView === 'initial' && (
						<Fragment>
							<h1 className="title">{strings.childTest}</h1>
							<h2 className="SelectRole__heading">
								{strings.chooseRole}
							</h2>
							<p>{strings.chooseRoleHelp}</p>
							<br />
							<div>
								<button
									className="SelectRole__select-button"
									onClick={() =>
										this.setState({
											currentView: 'testadmin',
										})
									}
								>
									{strings.testadministrator}
								</button>
								<button
									className="SelectRole__select-button"
									onClick={() =>
										this.setState({
											currentView: 'candidate',
										})
									}
								>
									{strings.testcandidate}
								</button>
							</div>
						</Fragment>
					)}
					{currentView === 'testadmin' && (
						<Fragment>
							{!hasEnteredCode && !this.state.altError && (
								<Fragment>
									<h2>{strings.testadministrator}</h2>

									<form
										onSubmit={(e) => {
											e.preventDefault();

											if (!this.state.askForPincode) {
												exchangeToken(testKey).then(
													(results) => {
														const pinCode =
															results.pinCode;
														const requireVerification =
															results.requireVerification;

														if (
															(results.testType ===
																'adult-followup' &&
																results.status !==
																	'isCompleted') ||
															(!requireVerification &&
																results.status ===
																	'notUsed')
														) {
															window.open(
																`${CHILD_TEST_URL}?key=${testKey}&role=admin&token=${results.token}&type=${results.testType}&group=${results.ageGroup}`,
																'_self'
															);
														}

														if (
															this.props
																.onStartTest
														) {
															this.props.onStartTest();
														} else {
															let instructionsText =
																results.status !==
																	'isCompleted' &&
																results.testType !==
																	'adult-followup' &&
																results.requireVerification ? (
																	<span>
																		Detta
																		test är
																		äldre än
																		en
																		månad.
																		För att
																		skydda
																		din
																		integritet
																		måste vi
																		bekräfta
																		att rätt
																		användare
																		startar
																		testet.
																		Vänligen
																		använd
																		pinkoden
																		som vi
																		har
																		skickat
																		till{' '}
																		<span
																			style={{
																				color: 'yellow',
																			}}
																		>
																			<i>
																				<u>
																					{results.adminEmail
																						? results.adminEmail
																						: 'din registrerade e-post'}
																				</u>
																			</i>{' '}
																		</span>{' '}
																		för att
																		starta
																		testet.
																	</span>
																) : null;
															if (
																results.status ===
																	'isUsed' &&
																results.testType !==
																	'adult-followup'
															) {
																instructionsText =
																	(
																		<span>
																			Detta
																			test
																			har
																			påbörjats
																			tidigare,
																			men
																			inte
																			slutförts.
																			För
																			att
																			skydda
																			din
																			integritet
																			måste
																			vi
																			bekräfta
																			att
																			rätt
																			användare
																			startar
																			testet.
																			Vänligen
																			använd
																			pinkoden
																			som
																			vi
																			har
																			skickat
																			till{' '}
																			<span
																				style={{
																					color: 'yellow',
																				}}
																			>
																				<i>
																					<u>
																						{results.adminEmail
																							? results.adminEmail
																							: 'din registrerade e-post'}
																					</u>
																				</i>{' '}
																			</span>{' '}
																			för
																			att
																			starta
																			testet.
																		</span>
																	);
															}
															const errorToThrow =
																results.status ===
																'isCompleted'
																	? 'Detta test är redan slutfört'
																	: null;

															const socketLink = `${CHILD_TEST_URL}?key=${testKey}&role=admin&token=${results.token}&type=${results.testType}&group=${results.ageGroup}`;
															this.setState({
																askForPincode: true,
																adminEmail:
																	results.adminEmail,
																redirectLink:
																	socketLink,
																pinCode:
																	pinCode,
																altError:
																	errorToThrow,
																instructions:
																	instructionsText,
															});
														}
														if (!results) {
															this.setState({
																instructions: (
																	<span
																		style={{
																			color: 'yellow',
																		}}
																	>
																		Testet
																		kan inte
																		startas.
																	</span>
																),
																askForPincode: false,
															});
														}
													}
												);
											}
											if (
												this.state.askForPincode &&
												this.state.userPin
											) {
												if (
													this.state.pinCode.toLowerCase() ===
													this.state.userPin.toLowerCase()
												) {
													window.open(
														this.state.redirectLink,
														'_self'
													);
													if (
														this.props.onStartTest
													) {
														this.props.onStartTest();
													}
												} else {
													this.setState({
														passCodeError:
															'Fel pinkod. Testet kan inte startas',
													});
												}
											}
											return false;
										}}
									>
										{!this.state.askForPincode && (
											<div className="SelectRole__label">
												<label htmlFor="testkey">
													{strings.testkey}
												</label>
												<input
													className="SelectRole__input"
													name="testkey"
													type="text"
													style={{
														textTransform:
															'uppercase',
													}}
													defaultValue={testKey}
													required
													placeholder="XXXXXXXX"
													onChange={(e) =>
														this.setState({
															testKey:
																e.target.value
																	.trim()
																	.toUpperCase(),
														})
													}
												/>
											</div>
										)}
										{this.state.instructions &&
											!this.state.askForPincode && (
												<div
													style={{
														width: '70%',
														margin: 'auto',
													}}
												>
													{this.state.instructions}
												</div>
											)}
										<div>
											{this.state.askForPincode &&
												this.state.instructions && (
													<>
														<div
															style={{
																width: '70%',
																margin: 'auto',
															}}
														>
															{
																this.state
																	.instructions
															}
														</div>
														<br></br>
														<input
															className="SelectRole__pinInput"
															name="testkey"
															type="text"
															required
															placeholder="XXXX"
															onChange={(e) => {
																this.setState({
																	userPin:
																		e.target.value.trim(),
																	passCodeError: false,
																});
															}}
														/>
														{this.state
															.passCodeError && (
															<div>
																<span
																	style={{
																		color: 'orange',
																		fontSize:
																			'20px',
																	}}
																>
																	{
																		this
																			.state
																			.passCodeError
																	}
																</span>
															</div>
														)}
													</>
												)}
										</div>

										<button
											className="SelectRole__submit-button"
											type="submit"
										>
											{strings.starttest}
										</button>
									</form>
								</Fragment>
							)}
							{hasEnteredCode && (
								<Login
									onLogin={this.onAdminSubmit}
									testKey={this.state.testKey}
								/>
							)}
						</Fragment>
					)}
					{currentView === 'candidate' && (
						<Fragment>
							<div>
							<h2>{strings.testcandidate}</h2>
																		
						</div>
						<div>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={
									this.welcome_audio
								} /* {this.assets.spoonerismIntroEnd} */
							/>{' '}
							{strings.candidateWelcome}
							</p>
						</div>
							<div >
								<p>
									{strings.candidateGoodLuck}
								</p>
							</div>
							<form onSubmit={this.onCandidateSubmit}>
								<input
									style={{textTransform: 'uppercase'}}
									type="text"
									onChange={(e) =>
										this.setState({
											roomKey: e.target.value
												.toUpperCase()
												.trim(),
										})
									}
								/>
								<button
									type="submit"
									style={{marginLeft: '10px'}}
								>
									{strings.gototest}
								</button>
							</form>
							{this.state.failStartInstruction && (
								<span className="candidate-start-fail">
									<p
										className="candidate-start-fail__instructions"
										style={{color: 'yellow'}}
									>
										<span style={{color: 'Coral'}}>
											<b>{strings.warning1} </b>
										</span>
										<em>{strings.warning1text}</em>
										<a
											target="_blank"
											rel="noopener noreferrer"
											href="https://literate.no/personvernerklaering/"
										>
											<u style={{color: 'lime'}}>
												{strings.myTests}
											</u>
										</a>
									</p>
								</span>
							)}
						</Fragment>
					)}
				</div>

				<div>
					<iframe
						src="https://mindmup.github.io/3rdpartycookiecheck/start.html"
						style={{display: 'none'}}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {error, iframeUrl, isInit, isAuthenticated} = state.auth;

	return {
		error,
		iframeUrl,
		isInit,
		isAuthenticated,
	};
};

const mapDispatchToProps = {
	setAuthToken: setAuthTokenAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectRole);
